import { offerActionTypes } from './Constants';

const initialState = {
	loading: false,
	loadingSubmit: false,
	submitResult: null,
	loadingAddressRequest: false,
	address: null,
	addressNotFound: false,
	abilityData: null,
};

export default function offerReducer(state = initialState, action) {
	const { type, payload } = action;
	const { data } = payload || {};

	switch (type) {
		case offerActionTypes.GET_OFFER_ABILITY:
			return {
				...state,
				loading: true,
			};
		case offerActionTypes.GET_OFFER_ABILITY_SUCCESS:
		case offerActionTypes.GET_OFFER_ABILITY_ERROR:
			return {
				...state,
				abilityData: data,
				loading: false,
			};
		case offerActionTypes.GET_FULL_ADDRESS:
			return {
				...state,
				loadingAddressRequest: true,
			};
		case offerActionTypes.GET_FULL_ADDRESS_SUCCESS:
			return {
				...state,
				address: data,
				loadingAddressRequest: false,
				addressNotFound: false,
			};
		case offerActionTypes.GET_FULL_ADDRESS_ERROR:
			return {
				...state,
				addressNotFound: true,
				loadingAddressRequest: false,
			};
		case offerActionTypes.OFFER_REQUEST:
			return {
				...state,
				loadingSubmit: true,
			};
		case offerActionTypes.OFFER_REQUEST_SUCCESS:
			return {
				...state,
				loadingSubmit: false,
				submitResult: 'success',
			};
		case offerActionTypes.OFFER_REQUEST_ERROR:
			return {
				...state,
				loadingSubmit: false,
				submitResult: 'error',
			};
		case offerActionTypes.CLEAR_OFFER_STATE:
			return initialState;
		default:
			return state;
	}
}
